import { getCustomization, KeyRegistrator } from "@multiweb/customization";
import { PARTICIPANT_TYPE_ATTRIBUTE_RENDERER, ROLE_USERS_ATTRIBUTE_RENDERER } from "../../../constants";
import { ParticipantTypeAttributeRenderer } from "../../../GridParticipants/customization/attributes/ParticipantType";
import { RoleUsersAttributeRenderer } from "../../../GridParticipants/customization/attributes/RoleUsers";
import { GridParticipantsTemplateRenderer } from "../../../GridParticipants/customization/templates/GridParticipantsTemplate";
import { RoleUsersTemplateRenderer } from "../../../GridParticipants/customization/templates/RoleUsersTemplate";
import { DefaultRowTemplate } from "../../../types";
import { LLFDefaultAttributeRenderer, LLFIconAttributeRenderer, LLFLOVAttributeRenderer } from "./renderers/attribute";
import { LLFAttributeRegistrator } from "./renderers/attribute/LLFAttributeRegistrator";
import { LLFLinkAttributeRenderer } from "./renderers/attribute/LLFLinkRenderer";
import { LLFDefaultTemplateRenderer } from "./renderers/template";
// Získání customizacni instance
const customizationInstance = getCustomization();

// Inicializace registratorů v customizacích
customizationInstance.liteListFrame.init(
    new LLFAttributeRegistrator(new LLFDefaultAttributeRenderer("LLFDefaultAttributeRenderer")),
    new KeyRegistrator(new LLFDefaultTemplateRenderer(DefaultRowTemplate.singleLine)),
);

// Registrace jednotlivých rendererů
//#region šablony atributů
customizationInstance.liteListFrame.attribute.register(new LLFIconAttributeRenderer("LLFIconAttributeRenderer"), 0);
customizationInstance.liteListFrame.attribute.register(new LLFLOVAttributeRenderer("LLFLOVAttribute"), 0);
customizationInstance.liteListFrame.attribute.register(new LLFLinkAttributeRenderer("LLFLinkAttributeRenderer"), 0);
//#endregion
//#region šablony řádků
customizationInstance.liteListFrame.templates.register(new LLFDefaultTemplateRenderer(DefaultRowTemplate.multiLine1));
customizationInstance.liteListFrame.templates.register(new LLFDefaultTemplateRenderer(DefaultRowTemplate.multiLine2));
customizationInstance.liteListFrame.templates.register(new LLFDefaultTemplateRenderer(DefaultRowTemplate.multiLine3));
//#endregion

//#region šablony pro WFDialog
customizationInstance.liteListFrame.attribute.register(new ParticipantTypeAttributeRenderer(PARTICIPANT_TYPE_ATTRIBUTE_RENDERER), 0);
customizationInstance.liteListFrame.attribute.register(new RoleUsersAttributeRenderer(ROLE_USERS_ATTRIBUTE_RENDERER), 0);
customizationInstance.liteListFrame.templates.register(new GridParticipantsTemplateRenderer());
customizationInstance.liteListFrame.templates.register(new RoleUsersTemplateRenderer());
//#endregion
